import styled from '@emotion/styled'

export const ContainerStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  // minHeight: '100px',
  fontSize: '1.5rem',
})
